<ngx-auth-layout>
    <h1 id="title" class="title">Login</h1>
    <p class="sub-title">Hello! Log in with your windows credentials.</p>
    
    <section class="links" aria-label="Social sign in">
      <div class="socials">
        <ng-container>
          <button nbButton status="primary" (click)="login()">Login</button>
        </ng-container>
      </div>
    </section>
  </ngx-auth-layout>